module.exports = __webpack_public_path__ + "img/new-tel.fa4c30cd.png";